import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const BASE_URL = process.env.REACT_APP_ENDPOINT as string;

// initialize an empty api service that we'll inject endpoints into later as needed
export const privateApi = createApi({
	baseQuery: fetchBaseQuery({
		baseUrl: `${BASE_URL}/api/`,
		prepareHeaders: (headers) => {
			const token = localStorage.getItem('userToken');
			if (token) {
				headers.set('authorization', `Bearer ${token}`);
			}
			return headers;
		},
	}),
	reducerPath: 'privateApi',
    tagTypes: ['Charts', 'PatientCards'],
    endpoints: () => ({}),
});
